import { renderQRCode, renderSwissCross } from "./qr-code";
import type { Data } from "./types";

export type { Data } from "./types";
export {
  calculateSCORReferenceChecksum,
  formatReference,
  isSCORReferenceValid,
} from "./utils";

export interface QRCodeRect {
  x: number;
  y: number;
  width: number;
  height: number;
  fill: "black" | "white";
}

/** Return the QR modules and mandatory Swiss cross as vector geometry. */
export function generateQRCodeGeometry(data: Data, size = 46): QRCodeRect[] {
  const rects: QRCodeRect[] = [];

  renderQRCode(data, size, (x, y, blockSize) => {
    rects.push({
      x,
      y,
      width: blockSize,
      height: blockSize,
      fill: "black",
    });
  });

  renderSwissCross(size, (x, y, width, height, fill) => {
    if (fill !== "black" && fill !== "white") {
      throw new Error(`Unsupported Swiss QR fill color: ${fill}`);
    }
    rects.push({ x, y, width, height, fill });
  });

  return rects;
}
